import Entity from "./Entity";

export default class News extends Entity {
    constructor(data) {
        super(data);

        this.attributeKeys = [
            "id", "title", "summary", "url", "publicationDate"
        ];
    }

    getId() {
        return this.get("id");
    }

    getTitle() {
        return this.get("title");
    }

    getSummary() {
        return this.get("summary");
    }

    getUrl() {
        return this.get("url");
    }

    getPublicationDate() {
        return this.get("publicationDate");
    }
}